import { combineReducers } from 'redux';
import { createReducer } from '../helpers/reduxHelpers';
import { createReducer as createReducerOrig, PayloadAction, current } from '@reduxjs/toolkit';
import * as Actions from '../actions/types';
import { ReducerInterface } from '../interfaces/ReducerInterface';
import { COLOR_THEME } from '../global/constants';

const setSettingLoaderReducer = createReducer({
  initialState: false,
  actionType: Actions.SET_SETTING_LOADER
});

const initialthemeState = {
  theme: 'light'
};

const seThemeModeReducer = createReducerOrig(initialthemeState, (builder) => {
  builder.addCase(Actions.UPDATE_THEME_MODE, (state, action: PayloadAction<ReducerInterface, never>) => {
    const user = JSON.parse(JSON.stringify(current(state)));
    user[action.payload.propsName] = action.payload.value;
    return user;
  });
});

const settingIntegrationReducer = createReducer({
  initialState: {},
  actionType: Actions.SET_SETTING_INTEGRATION
});

const subscriptionListReducer = createReducer({
  initialState: [],
  actionType: Actions.SET_SUBSCRIPTION_LIST
});

const invoiceSettingReducer = createReducer({
  initialState: {},
  actionType: Actions.SET_INVOICE_SETTING
});

const initialNotificationState = {
  Browser: false,
  Email: false,
  Mobile: false
};

const notificationSettingDetailsReducer = createReducerOrig(initialNotificationState, (builder) => {
  builder
    .addCase(
      Actions.SET_NOTIFICATIONS_SETTING_DETAIL,
      (state = initialNotificationState, action: PayloadAction<any, never>) => {
        return { ...(action.payload || {}) };
      }
    )
    .addCase(Actions.UPDATE_NOTIFICATIONS_SETTING_DETAIL, (state, action: PayloadAction<ReducerInterface, never>) => {
      const user = JSON.parse(JSON.stringify(current(state)));
      user[action.payload.propsName] = action.payload.value;
      let updatedValue = true;
      if (action.payload.propsName === 'updated') {
        updatedValue = action.payload.value;
      }
      return { ...user, updated: updatedValue };
    })
    .addCase(Actions.CLEAR_NOTIFICATIONS_SETTING_DETAIL, () => {
      const count = JSON.parse(JSON.stringify(initialNotificationState));
      return count;
    });
});

const themeTypeReducer = createReducer({
  initialState: COLOR_THEME.LIGHT,
  actionType: Actions.SET_THEME_TYPE
});

const settingReducer = combineReducers({
  loading: setSettingLoaderReducer,
  themeMode: seThemeModeReducer,
  settingIntegration: settingIntegrationReducer,
  subscriptionList: subscriptionListReducer,
  invoiceSetting: invoiceSettingReducer,
  notificationSettingDetails: notificationSettingDetailsReducer,
  themeType: themeTypeReducer
});

export default settingReducer;
